import classNames from 'classnames';
import React, { memo } from 'react';

import { Button, Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { useDictionaries } from '../../../hooks/news';
import { Card } from '../Card';
import { IListsCardProps } from '../types';
import { getTestButtonText } from '../utils/getTestButtonText';

import styles from './main-list-card.module.scss';

export const MaterialCard = memo<IListsCardProps>(
  ({ material, index, size, materialType, color, useLazyLoad = true, direction = 'vertical', withImage = true }) => {
    const {
      alias,
      commentsCount,
      canCreateNewComments,
      likes,
      rubric,
      visits,
      picture,
      miniPicture,
      publishDate,
      pubDate,
      title,
      tags,
    } = material;

    const isMobile = useIsMobile();
    const { rubrics } = useDictionaries();

    const cardSmall = size === 'small';
    const cardDark = color === 'dark';

    const currentRubric = rubrics?.find((el) => el.value === rubric);

    const buttonText = getTestButtonText(tags);
    return (
      <Card
        className={classNames(cardSmall && styles.cardSmall, cardDark && styles.cardDark)}
        direction={direction}
        size={size}
        color={color}
      >
        {withImage && (picture || miniPicture) && (
          <Card.Image
            alt={title}
            //@ts-ignore
            src={picture?.url || miniPicture}
            lazy={useLazyLoad}
            width={picture?.width}
            height={picture?.height}
            shieldText={material.advertisingShieldText}
          />
        )}
        <Card.Content>
          {!cardSmall && materialType !== 'question' && (
            <Card.Row>
              {currentRubric && <Card.Rubric rubric={currentRubric} />}
              <Space size={12}>
                {tags.includes('Партнёрский материал') && <Card.Tag>Партнерский материал</Card.Tag>}
              </Space>
            </Card.Row>
          )}
          <Card.Row>
            <Card.Title id={alias} as={index === 0 ? 'h1' : 'h2'}>
              {title}
            </Card.Title>
          </Card.Row>
          <Card.DescriptionRow
            date={publishDate || pubDate}
            comments={commentsCount}
            canCreateNewComments={canCreateNewComments}
            likes={likes}
            visits={visits}
          />
          {materialType === 'test' && buttonText && !isMobile && (
            <div className={!cardSmall && 'h-mb-16'}>
              <Button size={36} className={styles.button}>
                {buttonText}
              </Button>
            </div>
          )}
          {materialType === 'question' && (
            <div className={'h-mt-16'}>
              <Button size={36} className={styles.button} variant={'primary'}>
                Узнать ответ
              </Button>
            </div>
          )}
        </Card.Content>
      </Card>
    );
  },
);
